import { FC } from "react";
import { ImageType } from "../helpers/useImages";
import ModalBuy from "./ModalBuy";
import useUser from "../helpers/useUser";

const BuyBox: FC<{ image: ImageType }> = ({ image }) => {
  return (
    <div className="buy-box" title={image.name}>
      <div className="top">
        <span>№ {image.id}</span>
        <div>
          <span>{image.resolution} п/д</span>
          <span>
            {image.sizes.widthSM}x{image.sizes.heightSM} см
          </span>
          <span>{image.format}</span>
        </div>
      </div>
      <div className={"bottom"}>
        <PriceBlock price={image.price} />
        <ModalBuy image={image} />
      </div>
    </div>
  );
};

const PriceBlock: FC<{ price: number }> = ({ price }) => {
  const [user] = useUser();

  if (user?.subscription.allowed) {
    return (
      <div
        className={"price vip"}
      >
        <span className={"old"}>{`${price} р.`}</span>
		<span className={"current"}>{`${Math.round(price / 2)} р.`}</span>
      </div>
    );
  }

  return <div className={"price"}>{`${price} р.`}</div>;
};

export default BuyBox;
